import React, {useEffect, useState} from 'react';
import NotificationPopupItem from 'components/notification/NotificationPopupItem';
import {getAllNotificationsRequest, notificationReadRequest} from 'util/api';
import UniversalOptionsList from 'components/universal/UniversalOptionsList';
import UniversalTypeFilter from 'components/universal/UniversalTypeFilter';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';
import confettiService from "../donate/ConfettiService";

const initialReadStatus = 'All';
const viewableTypes = [
    ['IMAGE_COMMENT', 'Image commented'],
    ['ITEM_SOLD', 'Item sold'],
    ['ITEM_BOUGHT', 'Item bought'],
    ['IMAGE_OVERTOOK', 'Image overtook'],
    ['COMMENT_REPLY', 'Comment replied'],
    ['IMAGE_LIKE', 'Image liked'],
    ['IMAGE_COMMENT_REACTED', 'Comment reacted'],
    ['SYSTEM_MESSAGE', 'System message'],
];

const NotificationPane = () => {
    const [notifications, setNotifications] = useState([]);
    const [filteredNotifications, setFilteredNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterReadStatus, setFilterReadStatus] = useState(initialReadStatus);
    const [filterNotificationType, setFilterNotificationType] = useState(viewableTypes.map(([key]) => key));
    const [allNotificationsSelected, setAllNotificationsSelected] = useState(true);

    useEffect(() => {
        const fetchNotifications = async () => {
            const data = await getAllNotificationsRequest();
            setNotifications(data);
            setLoading(false);
        };

        fetchNotifications();
    }, []);

    useEffect(() => {
        let filtered = [...notifications];

        if (filterReadStatus !== 'All') {
            filtered = filtered.filter(notification =>
                (filterReadStatus === 'Read') === notification.b.seen
            );
        }

        const typeSet = new Set(filterNotificationType);
        filtered = filtered.filter(notification => typeSet.has(notification.b.topic));

        setFilteredNotifications(filtered);
    }, [filterReadStatus, filterNotificationType, notifications]);

    useEffect(() => {
        const allType = viewableTypes.map(([key]) => key);
        if (filterNotificationType.length === allType.length) {
            setAllNotificationsSelected(true);
        } else {
            setAllNotificationsSelected(false);
        }
    }, [filterNotificationType]);

    const handleNotificationTypeClicked = (key) => {
        if (filterNotificationType.includes(key)) {
            setFilterNotificationType(filterNotificationType.filter(type => type !== key));
        } else {
            setFilterNotificationType([...filterNotificationType, key]);
        }
    };

    const handleShowAllClicked = () => {
        if (allNotificationsSelected) {
            setFilterNotificationType([]);
        } else {
            setFilterNotificationType(viewableTypes.map(([key]) => key));
        }
    };

    const onNotificationRead = (id, message) => {
        notificationReadRequest(id).then(() => {
            let confettiCount = confettiService.calculateConfettiCount(message);
            confettiService.fire(confettiCount);
            setNotifications((prevNotifications) => {
                // Mark the clicked notification as read
                return prevNotifications.map((notification) => {
                    if (notification.id === id) {
                        notification.b.seen = true;
                    }
                    return notification;
                });
            });
        });
    };

    return (
        <div>
            <UniversalEmptyPageHeader text={'Notifications'} image={'bell'} desktopText={true}/>

            <div className="notification-filters">
                <UniversalOptionsList
                    initialOption={initialReadStatus}
                    options={['Unread', 'All', 'Read']}
                    onOptionClick={(option) => setFilterReadStatus(option)}
                />
                <UniversalTypeFilter
                    types={[['SHOW_ALL', 'Show all types']]}
                    highlightedKeys={allNotificationsSelected ? ['SHOW_ALL'] : []}
                    itemClicked={handleShowAllClicked}
                />
                <UniversalTypeFilter
                    types={viewableTypes}
                    highlightedKeys={filterNotificationType}
                    itemClicked={handleNotificationTypeClicked}
                />
            </div>

            {loading ? (
                <div>Loading notifications...</div>
            ) : filteredNotifications.length > 0 ? (
                <div className="notifications-list">
                    {filteredNotifications.map((notification) => (
                        <NotificationPopupItem
                            key={notification.id}
                            notification={notification}
                            onNotificationRead={onNotificationRead}
                        />
                    ))}
                </div>
            ) : (
                <div style={{paddingLeft: '16px'}}>No notifications to display.</div>
            )}
        </div>
    );
};

export default NotificationPane;
